const sapaan = () => ([]);
const agama = () => ([]);
const jenisKelamin = () => ([
	{
		title: "Laki-laki",
		name: "jenis-kelamin",
		value: "1",
		id: "jkl",
	},
	{
		title: "Perempuan",
		name: "jenis-kelamin",
		value: "0",
		id: "jlp",
	},
]);
const karyawanAll = () => []
const konsumen = () => []
const konsumenTiny = () => []
const tahapan = () => []
const mesinAll = () => []
const akunKeuangan = () => []
const akunDebit = () => []
const akunEDC = () => []
const workshop = () => []
const akunKeuanganGlobal = () => []
const financialAccountFund = () => []
const listAssetsAccount = () => []
const listKeuanganKasOutlet = () => []
const listKeuanganKasWorkshop = () => []
const listKeuanganBiaya = () => []
const listKeuanganOwner = () => []
const listBiayaItemKategori = () => []

const state = {
	sapaan: sapaan(),
	agama: agama(),
	jenisKelamin: jenisKelamin(),
	karyawanAll: karyawanAll(),
	konsumen: konsumen(),
	konsumenTiny: konsumenTiny(),
	tahapan: tahapan(),
	mesinAll: mesinAll(),
	akunKeuangan: akunKeuangan(),
	akunDebit: akunDebit(),
  dataMCoin: {},
  shortcode: [],
	akunEDC: akunEDC(),
	workshop: workshop(),
	akunKeuanganGlobal: akunKeuanganGlobal(),
	financialAccountFund: financialAccountFund(),
	listKeuanganKasOutlet: listKeuanganKasOutlet(),
	listKeuanganKasWorkshop: listKeuanganKasWorkshop(),
	listKeuanganBiaya: listKeuanganBiaya(),
	listKeuanganOwner: listKeuanganOwner(),
	listBiayaItemKategori: listBiayaItemKategori(),
	listAssetsAccount: listAssetsAccount(),
	betaFeatureOwnerAccess: {},
	showQrisManagementMenu: true,
	aclList: [],
	isFetchBetaOwner: false,
	isWebview: false,
	initRoute: null,
	isOpenBetaModal: false,
	topServiceSummary: [],
	whitelabelSetting: {},
	isWhitelabel: null,
}

export {
	state as default,
	sapaan,
	agama,
	jenisKelamin,
	karyawanAll,
	tahapan,
	mesinAll,
	akunKeuangan,
	workshop,
	akunKeuanganGlobal,
	financialAccountFund,
	listKeuanganKasOutlet,
	listKeuanganKasWorkshop,
	listKeuanganBiaya,
	listKeuanganOwner,
	listBiayaItemKategori,
}